import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { ProductoService } from 'src/app/services/producto.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { FacturaManualCabeceraComponent } from '../factura-manual-cabecera/factura-manual-cabecera.component';
import { DocumentoDetalleService } from 'src/app/services/documento-detalle.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-factura-manual-detalles',
  templateUrl: './factura-manual-detalles.component.html',
  styleUrls: ['./factura-manual-detalles.component.scss'],
  providers: [SecurityService],
})
export class FacturaManualDetallesComponent implements OnInit {
  @Output() onAddProduct: EventEmitter<any> = new EventEmitter<any>();
  @Output() onProductAdded: EventEmitter<'LIBRE' | 'NO_FACTURABLE' | 'NORMAL'> = new EventEmitter<'LIBRE' | 'NO_FACTURABLE' | 'NORMAL'>();
  @Output() onDetalleDocumentoChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() cabeceraComponent: FacturaManualCabeceraComponent;
  @Input() permiteUnidadNegocio: boolean = false;

  // Modales
  @ViewChild('agregarNoFacturable', { static: true }) modalAgregarNoFacturable: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Constantes
  readonly PRODUCTO_LIBRE_AFECTO: String = '_PRODUCTO_LIBRE_AFECTO';
  readonly PRODUCTO_LIBRE_EXCENTO: String = '_PRODUCTO_LIBRE_EXCENTO';

  // Form
  formDetails: FormGroup;
  formNoFactuable: FormGroup;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  detailsData: any = null;
  optionsFormato: Array<any> = [];
  optionsFormatoProductoLibre: Array<any> = [{ value: 'UNID', label: 'Unidad' }];
  // productoSeleccionado: any = null
  cliente: any = null; // Viene desde Cabecera
  sucursal: any = null;
  detalleDocumento: Array<any> = [];
  totalesDocumento: any = null;
  lastHeaderDataRecibed: any = null;

  // Getters
  get disableEliminar() {
    return this.detalleDocumento.filter((p) => p.eliminar_linea).length === 0;
  }
  // disableEliminar: Boolean = true // Cambié el getter porque se llama a cada cambio

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private productoService: ProductoService,
    private formatoProductoService: FormatoProductosService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private documentoService: DocumentoService,
    private documentoDetalleService: DocumentoDetalleService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('PRODUCTOS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForms();
    this.formChangesSubscriptions();
  }

  createForms() {
    this.formDetails = this.fb.group({
      esProductoLibre: [false],
      productoLibre: this.fb.group({
        codigo: ['', [Validators.required, Validators.min(1)]],
        descripcion: ['', [Validators.required]],
        cantidad: [null, [Validators.required, Validators.min(1)]],
        formato: ['UNID', [Validators.required]],
        precioUnitario: [0, [Validators.required, Validators.min(1)]],
        es_exento: [this.PRODUCTO_LIBRE_AFECTO, [Validators.required]],
      }),
      productoExistente: this.fb.group({
        codigo: ['', [Validators.required, Validators.min(1)]],
        cantidad: [null, [Validators.required, Validators.min(1)]],
        formato: [null, [Validators.required]],
        precioUnitario: [null, [Validators.required]],
      }),
      descuento: this.fb.group({
        porcentaje: [null, []], //[Validators.min(1), Validators.max(100)]],
        monto: [null, []], // [Validators.required]],
      }),
      recargo: this.fb.group({
        porcentaje: [null, []], //[Validators.min(1), Validators.max(100)]],
        monto: [null, []], //[Validators.required]],
      }),
    });
    this.formDetails.get('productoLibre.codigo').disable();

    this.formNoFactuable = this.fb.group({
      nombre: ['', [Validators.required]],
    });
  }

  resetProductoNoFacturableData() {
    this.formNoFactuable.reset();
    this.formNoFactuable.markAsPristine();
    this.formNoFactuable.markAsUntouched();

    this.formNoFactuable.get('nombre').setValue('');
  }

  resetProductoLibreData() {
    // this.formDetails.reset()
    this.formDetails.markAsPristine();
    this.formDetails.markAsUntouched();

    this.formDetails.get('productoLibre.codigo').setValue('');
    this.formDetails.get('productoLibre.descripcion').setValue('');
    this.formDetails.get('productoLibre.cantidad').setValue(null);
    this.formDetails.get('productoLibre.formato').setValue('UNID');
    this.formDetails.get('productoLibre.precioUnitario').setValue(0);
    this.formDetails.get('productoLibre.es_exento').setValue(this.PRODUCTO_LIBRE_AFECTO);
  }

  resetProductoExistenteData() {
    // this.formDetails.reset()
    this.optionsFormato = [];
    this.formDetails.get('productoExistente.codigo').setValue('');
    this.formDetails.get('productoExistente.cantidad').setValue(null);
    this.formDetails.get('productoExistente.formato').setValue(null);
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);

    this.formDetails.get('descuento.porcentaje').setValue(null);
    this.formDetails.get('descuento.monto').setValue(null);

    this.formDetails.get('recargo.porcentaje').setValue(null);
    this.formDetails.get('recargo.monto').setValue(null);

    if (this.detailsData) this.detailsData.productoSeleccionado = null;

    this.modalSeleccionarProducto.clearLast();

    this.formDetails.markAsPristine();
    this.formDetails.markAsUntouched();
  }

  formChangesSubscriptions() {
    // esProductoLibre
    // this.formDetails.get("esProductoLibre").valueChanges.subscribe(esProductoLibre => {
    //   if (esProductoLibre) {
    //     this.formDetails.get("productoExistente.codigo").setValidators(null)
    //     this.formDetails.get("productoExistente.cantidad").setValidators(null)
    //     this.formDetails.get("productoExistente.formato").setValidators(null)
    //     this.formDetails.get("productoExistente.precioUnitario").setValidators(null)

    //     this.formDetails.get("productoLibre.codigo").setValidators([Validators.required])
    //     this.formDetails.get("productoLibre.descripcion").setValidators([Validators.required])
    //     this.formDetails.get("productoLibre.cantidad").setValidators([Validators.required, Validators.min(1)])
    //     this.formDetails.get("productoLibre.formato").setValidators([Validators.required])
    //     this.formDetails.get("productoLibre.precioUnitario").setValidators([Validators.required, Validators.min(1)])
    //   } else {
    //     this.formDetails.get("productoLibre.codigo").setValidators(null)
    //     this.formDetails.get("productoLibre.descripcion").setValidators(null)
    //     this.formDetails.get("productoLibre.cantidad").setValidators(null)
    //     this.formDetails.get("productoLibre.formato").setValidators(null)
    //     this.formDetails.get("productoLibre.precioUnitario").setValidators(null)

    //     this.formDetails.get("productoExistente.codigo").setValidators([Validators.required, Validators.min(1)])
    //     this.formDetails.get("productoExistente.cantidad").setValidators([Validators.required, Validators.min(1)])
    //     this.formDetails.get("productoExistente.formato").setValidators([Validators.required])
    //     this.formDetails.get("productoExistente.precioUnitario").setValidators([Validators.required])
    //   }
    // })

    // formato
    this.formDetails.get('productoExistente.formato').valueChanges.subscribe((formato) => this.handleFormatoChange());

    // código de producto
    this.formDetails
      .get('productoExistente.codigo')
      .valueChanges.pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo);
      });

    // toggle descuentos y recargos | descuento | porcentaje/pesos clp
    this.formDetails
      .get('descuento.porcentaje')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'descuento.porcentaje', 'descuento.monto', true);
      });
    this.formDetails
      .get('descuento.monto')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'descuento.monto', 'descuento.porcentaje', false);
      });

    // toggle descuentos y recargos | recargo | porcentaje/pesos clp
    this.formDetails
      .get('recargo.porcentaje')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'recargo.porcentaje', 'recargo.monto', true);
      });
    this.formDetails
      .get('recargo.monto')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'recargo.monto', 'recargo.porcentaje', false);
      });
  }

  togglePorcentajeMontoValuesAndValidators(value, currentFormControlName, previousFormControlName, isPorcentaje) {
    if (value) {
      // remove validators
      // this.formDetails.get(currentFormControlName).setValidators(null)
      this.formDetails.get(previousFormControlName).setValidators(null);
      this.formDetails.get(previousFormControlName).setValue(null);
      this.formDetails.get(previousFormControlName).updateValueAndValidity();

      // set validator
      // this.formDetails.get(currentFormControlName).setValidators([Validators.required, Validators.min(1)])
      const validators = [Validators.required, Validators.min(0)];
      if (isPorcentaje) validators.push(Validators.max(99.9999));
      this.formDetails.get(currentFormControlName).setValidators(validators);
      this.formDetails.get(currentFormControlName).updateValueAndValidity();
    }
  }

  abrirModalSeleccionarProducto() {
    // this.modalSeleccionarProducto.show()
    if (!this.validateUnidadNegocioCabecera()) {
      this.showMessageSeleccionUnidadNegocio();
      return;
    }

    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();

    console.log('unidad de negocio ', unidad_negocio_codigo);
    this.modalSeleccionarProducto.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      showInforAdicionar: true,
      defaultUnidadNegocio: unidad_negocio_codigo,
    });
  }

  checkOrInitDetailsData() {
    if (!this.detailsData) this.detailsData = {};
  }

  getProducts({ inputParams: modalInputParams, callback }) {
    const self = this;

    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();

    this.log(modalInputParams);
    const inputParams = {
      empresa_rut: modalInputParams.empresa_rut,
      sucursal_codigo: modalInputParams.sucursal_codigo,
      sku: modalInputParams.sku,
      descripcion: modalInputParams.descripcion,
      tipobusquedad_afecto_exento: modalInputParams.tipobusquedad_afecto_exento,
      familia: modalInputParams.familia,
      rubro: modalInputParams.rubro,
      unidad_negocio_codigo: modalInputParams.unidad_negocio_codigo ? modalInputParams.unidad_negocio_codigo : unidad_negocio_codigo,
      paginaActual: modalInputParams.paginaActual,
      cantidadRegistrosPorPagina: modalInputParams.cantidadRegistrosPorPagina,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.productoService.obtenerSegunFiltroProductosFacturables(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (!respuesta) {
        callback(new QueryResult(null, 0, 0, 0));
        return;
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
    });
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.checkOrInitDetailsData();
    this.detailsData.productoSeleccionado = _productoSeleccionado;
    this.cleanProductoSeleccionadoRelateds();
    this.formDetails.get('productoExistente.codigo').setValue(_productoSeleccionado.sku);

    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.detailsData.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
      this.formDetails.get('productoExistente.formato').setValue(null);
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('productoExistente.formato'), this.optionsFormato);
    });
  }

  cleanProductoSeleccionadoRelateds() {
    this.optionsFormato = [];
    this.formDetails.get('productoExistente.formato').setValue(null);
    this.formDetails.get('productoExistente.cantidad').setValue(null);
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);

    this.formDetails.get('productoExistente').markAsPristine();
    this.formDetails.get('productoExistente').markAsUntouched();
  }

  onProductoNoEncontrado() {
    this.limpiarDataProductoSeleccionado();
  }

  // Método consumido desde parent
  handleClienteChange(cliente) {
    this.cliente = cliente;
    if (cliente) this.getPrecioUnitario();
    else this.clearPrecioUnitario();
  }

  clearPrecioUnitario() {
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);
  }

  handleFormatoChange() {
    this.getPrecioUnitario();
  }

  getPrecioUnitario() {
    if (!this.cliente || !this.detailsData || !this.detailsData.productoSeleccionado || !this.formDetails.get('productoExistente.formato').value) return;

    // Limpiar
    this.clearPrecioUnitario();

    const formatoSeleccionado = this.formDetails.get('productoExistente.formato').value;
    const inputParams: any = {
      empresa_rut: this.rutEmpresa,
      producto_codigo: this.detailsData.productoSeleccionado.codigo,
      formato_codigo: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_codigo,
      lista_precio_codigo: this.cliente.lista_precio_codigo,
      tipo_producto_codigo: this.detailsData.productoSeleccionado.tipo_producto_codigo,
    };

    this.log('precio unitario', JSON.stringify(inputParams));
    this.productoService.GetPrecioUnitario(inputParams, ({ precio_unitario }) => {
      this.formDetails.get('productoExistente.precioUnitario').setValue(precio_unitario);
    });
  }

  limpiarDataProductoSeleccionado() {
    this.checkOrInitDetailsData();
    this.formDetails.get('productoExistente.cantidad').setValue(null);
    this.detailsData.productoSeleccionado = null;

    this.optionsFormato = [];
    this.formDetails.get('productoExistente.formato').setValue(null);
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);
  }

  showModalNoFacturable() {
    if (!this.validateUnidadNegocioCabecera()) {
      this.showMessageSeleccionUnidadNegocio();
      return;
    }
    this.limpiarModalNoFacturable();
    this.modalAgregarNoFacturable.show();
  }

  limpiarModalNoFacturable() {
    this.formNoFactuable.reset();
    this.formNoFactuable.get('nombre').setValue('');
  }

  hideModalNoFacturable() {
    this.modalAgregarNoFacturable.hide();
  }

  // Este dispara los otros 3
  agregarProductoGenerico(tipo) {
    if (!this.validateUnidadNegocioCabecera()) {
      this.showMessageSeleccionUnidadNegocio();
      return;
    }

    if (this.formDetails.get('productoLibre.cantidad').value > 0 && this.formDetails.get('productoLibre.formato').value) {
      //Si existen valores dentro de productoLibre se limpia productoExistente
      this.formDetails.get('productoExistente.codigo').setValue(null);
      this.formDetails.get('productoExistente.cantidad').setValue(null);
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('productoExistente.formato'), this.optionsFormato);

      // se valida si existe cantidad y formato de productoLibre
      if (this.formDetails.get('productoLibre.cantidad').value > 1 && this.formDetails.get('productoLibre.formato').value.includes('MED')) {
        this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
        return;
      }
    }

    if (this.formDetails.get('productoExistente.cantidad').value > 1 && this.formDetails.get('productoExistente.formato').value.includes('MED')) {
      this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
      return;
    }

    this.onAddProduct.emit(tipo);
  }

  // No facturable
  agregarProductoNoFacturable(headerData) {
    this.lastHeaderDataRecibed = headerData;
    this.formValidatorsService.validateAllFormFields(this.formNoFactuable);
    if (!this.formNoFactuable.valid) {
      return;
    }

    this.sucursal = headerData.sucursal;

    const _variables = {
      entidad_detalleDTO: {
        // tipo_dte_codigo: 0,
        // producto_codigo: 0,
        // formato_codigo: '',
        descripcion_producto: this.formNoFactuable.get('nombre').value.trim(),
        // cantidad: 0,
        // precio_unitario: 0,
        // descuento_linea_pesos: 0,
        // descuento_linea_porcentaje: 0,
        // recargo_linea_porcentaje: 0,
        // recargo_linea_pesos: 0,
        // es_afecto_reglas_comerciales: false
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: headerData.sucursal.codigo,
          lista_precio_codigo: this.cliente.lista_precio_codigo,
          es_exenta: !headerData.facturaAfecta,
          afecto_reglas_comerciales: this.cliente.afecto_reglas_comerciales,
        },
        descuentosGlobales: headerData.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento),
      },
    };

    this.log(`agregar producto Nno facturable`, JSON.stringify(_variables));

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              agregarDetalleProductoNoFacturable(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    no_aplica_descuento
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    tipo_producto_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento_detalle.agregarDetalleProductoNoFacturable;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }

        self.resetProductoNoFacturableData();
        self.handleAddDetailResponse(response.data.documento_detalle.agregarDetalleProductoNoFacturable, headerData);
        self.hideModalNoFacturable();
        self.onProductAdded.emit('NO_FACTURABLE');
      }
    );
  }

  public agregarProductoLibre(headerData) {
    this.lastHeaderDataRecibed = headerData;
    this.formValidatorsService.validateAllFormFields(this.formDetails.get('productoLibre') as FormGroup);
    if (!this.formDetails.get('productoLibre').valid) {
      return;
    }

    this.sucursal = headerData.sucursal;

    let inputParams: any = {
      entidad_detalleDTO: {
        sku: null, // Number(this.formDetails.get("productoLibre.codigo").value),
        producto_codigo: null, // Number(this.formDetails.get("productoLibre.codigo").value), // TODO: Alfanumerico o numerico? // 1,
        formato_codigo: this.formDetails.get('productoLibre.formato').value, // 'CJX6',
        descripcion_producto: this.formDetails.get('productoLibre.descripcion').value,
        cantidad: Number(this.formDetails.get('productoLibre.cantidad').value),
        precio_unitario: Number(this.formDetails.get('productoLibre.precioUnitario').value),
        es_exento: this.formDetails.get('productoLibre.es_exento').value === this.PRODUCTO_LIBRE_EXCENTO,

        // // default
        // tipo_dte_codigo: 0,
        // descuento_linea_pesos: 0,
        // descuento_linea_porcentaje: 0,
        // recargo_linea_porcentaje: 0,
        // recargo_linea_pesos: 0,
        // es_afecto_reglas_comerciales: false
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: headerData.sucursal.codigo,
          lista_precio_codigo: this.cliente.lista_precio_codigo,
          es_exenta: !headerData.facturaAfecta,
          afecto_reglas_comerciales: this.cliente.afecto_reglas_comerciales,
        },
        descuentosGlobales: headerData.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento),
      },
    };

    this.log(`agregar producto libre`, JSON.stringify(inputParams));

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              agregarDetalleProductoLibre(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    no_aplica_descuento
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    tipo_producto_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento_detalle.agregarDetalleProductoLibre;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }

        self.resetProductoLibreData();
        self.handleAddDetailResponse(response.data.documento_detalle.agregarDetalleProductoLibre, headerData);
        self.onProductAdded.emit('LIBRE');
      }
    );
  }

  // Agregar Producto
  agregarProducto(headerData) {
    this.lastHeaderDataRecibed = headerData;
    this.formValidatorsService.validateAllFormFields(this.formDetails.get('productoExistente') as FormGroup);
    // this.formValidatorsService.validateAllFormFields(this.formDetails.get('descuento') as FormGroup);
    // this.formValidatorsService.validateAllFormFields(this.formDetails.get('recargo') as FormGroup);
    if (
      !this.formDetails.get('productoExistente').valid
      // || !this.formDetails.get('descuento').valid
      // || !this.formDetails.get('recargo').valid
    ) {
      return;
    }

    const { cliente } = headerData;
    if (this.formDetails.get('productoExistente.precioUnitario').value === '0' || this.formDetails.get('productoExistente.precioUnitario').value === 0) {
      this.toastService.error(`El Producto indicado no posee Precio en Lista ${cliente.lista_precio_codigo}`);
      return;
    }

    this.sucursal = headerData.sucursal;

    const { productoSeleccionado } = this.detailsData;

    const descuentoEsPorcentaje = this.formDetails.get('descuento.porcentaje').value !== null;
    const recargoEsPorcentaje = this.formDetails.get('recargo.porcentaje').value !== null;
    const inputParams = {
      entidad_detalleDTO: {
        sku: productoSeleccionado.sku,
        producto_codigo: productoSeleccionado.codigo,
        formato_codigo: this.formDetails.get('productoExistente.formato').value, // 'CJX6',
        descripcion_producto: productoSeleccionado.descripcion, // '',
        cantidad: Number(this.formDetails.get('productoExistente.cantidad').value), // 5,
        precio_unitario: Number(this.formDetails.get('productoExistente.precioUnitario').value),
        descuento_linea_pesos: descuentoEsPorcentaje ? 0 : Number(this.formDetails.get('descuento.monto').value),

        // descuento_linea_porcentaje: descuentoEsPorcentaje ? this.formDetails.get("descuento.porcentaje").value : 0,
        descuento_linea_porcentaje: descuentoEsPorcentaje
          ? this.formDetails.get('descuento.porcentaje').value
            ? Number(this.formDetails.get('descuento.porcentaje').value.replace(',', '.'))
            : null
          : 0,

        recargo_linea_pesos: recargoEsPorcentaje ? 0 : Number(this.formDetails.get('recargo.monto').value),

        // recargo_linea_porcentaje: recargoEsPorcentaje ? this.formDetails.get("recargo.porcentaje").value : 0,
        recargo_linea_porcentaje: recargoEsPorcentaje ? (this.formDetails.get('recargo.porcentaje').value ? Number(this.formDetails.get('recargo.porcentaje').value.replace(',', '.')) : null) : 0,

        es_exento: productoSeleccionado.es_exento,
        es_afecto_reglas_comerciales: productoSeleccionado.afecto_reglas_comerciales,
        no_aplica_descuento: productoSeleccionado.no_aplica_descuento,
        tipo_producto_codigo: this.detailsData.productoSeleccionado.tipo_producto_codigo,
        unidad_negocio_codigo: productoSeleccionado.unidad_negocio_codigo,
        // defaults
        // tipo_dte_codigo: 0,
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: headerData.sucursal.codigo,
          lista_precio_codigo: this.cliente.lista_precio_codigo,
          es_exenta: !headerData.facturaAfecta,
          afecto_reglas_comerciales: this.cliente.afecto_reglas_comerciales,
        },
        descuentosGlobales: headerData.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento),
      },
    };

    this.log(`agregar producto`, JSON.stringify(inputParams));

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              validarAgregarDetalle(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    no_aplica_descuento
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    tipo_producto_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento_detalle.validarAgregarDetalle;
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }

        self.resetProductoExistenteData();
        self.handleAddDetailResponse(response.data.documento_detalle.validarAgregarDetalle, headerData);
        self.bloquearUnidadNegocioCabecera(productoSeleccionado);
        self.onProductAdded.emit('NORMAL');
      }
    );
  }

  bloquearUnidadNegocioCabecera(productoSeleccionado) {
    this.cabeceraComponent.disableUnidadNegocio(productoSeleccionado ? productoSeleccionado.unidad_negocio_codigo : null);
  }

  private handleAddDetailResponse(response, headerData) {
    const { respuesta, mensajes } = response;

    const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
    if (!ok) {
      this.messageRendererService.showErrors(mensajes);
      return;
    }

    let { registros } = respuesta;
    if (!registros) return;

    this.toastService.success('Producto agregado');
    // registros = this.configInitialDetails(registros)
    this.configInitialDetails(registros);
    this.detalleDocumento = registros;

    this.obtenerTotalesDocumento(headerData);
  }

  private configInitialDetails(details) {
    details.map((p, index) => {
      p.eliminar_linea = false;
      p.index = index;
      delete p.__typename;
      if (p.atributos)
        p.atributos.map((attr) => {
          delete attr.__typename;
        });
    });
  }

  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach((val) => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map((p) => {
      if (cleanCheck) delete p.eliminar_linea;
      delete p.index;
      delete p.aplicacion_descuento;
      delete p.aplicacion_recargo;
      if (p.atributos !== null) {
        p.atributos.map((attr) => {
          delete attr.__typename;
        });
      }
    });
    return _detalledocumento;
  }

  // Obtener totales
  public obtenerTotalesDocumento(headerData) {
    const inputParams = {
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: headerData.sucursal.codigo,
          lista_precio_codigo: this.cliente.lista_precio_codigo,
        },
        descuentosGlobales: headerData.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento),
      },
    };

    this.documentoService.ObtenerTotalesDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.totalesDocumento = respuesta;
    });
  }

  checkAllChange({ checked }) {
    this.detalleDocumento.forEach((mov) => {
      mov.eliminar_linea = checked;
    });
  }

  checkDetalle({ index }) {
    const selected = this.detalleDocumento.filter((p) => p.index === index)[0];
    selected.eliminar_linea = !selected.eliminar_linea;
  }

  eliminarSeleccionados() {
    if (this.detalleDocumento.filter((p) => p.eliminar_linea).length === 0) {
      this.toastService.warning('Seleccione productos(s) para eliminar');
      return;
    }
    this.modalConfirm.show(() => {
      this.eliminarSeleccionadosQuery();
    });
  }

  private eliminarSeleccionadosQuery() {
    const _variables = {
      entidad_detalleDTO: {},
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: this.sucursal.codigo,
          lista_precio_codigo: this.cliente.lista_precio_codigo,
        },
        descuentosGlobales: this.lastHeaderDataRecibed.descuentosGlobales,
        detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento, false),
      },
    };

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              eliminarDetalleProducto(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    no_aplica_descuento
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    tipo_producto_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento_detalle.eliminarDetalleProducto;

        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }

        const { registros } = respuesta;
        if (!registros) return;

        self.toastService.success('Producto(s) eliminado(s)');
        self.configInitialDetails(registros);
        self.detalleDocumento = registros;

        self.obtenerTotalesDocumento(self.lastHeaderDataRecibed);
      }
    );
  }

  getDetailsData() {
    return {
      detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento),
      totalesDocumento: this.totalesDocumento,
    };
  }

  clearContents() {
    this.detailsData = null;
    this.optionsFormato = [];
    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.cliente = null; // Viene desde Cabecera
    this.sucursal = null;
    this.detalleDocumento = [];
    this.totalesDocumento = null;
    this.lastHeaderDataRecibed = null;

    this.resetProductoNoFacturableData();
    this.resetProductoLibreData();
    this.resetProductoExistenteData();
  }

  validateUnidadNegocioCabecera(): boolean {
    if (!this.permiteUnidadNegocio) return true;
    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
    return !!unidad_negocio_codigo;
  }

  showMessageSeleccionUnidadNegocio(): void {
    this.toastService.warning('Seleccione unidad de negocio');
  }

  updateChange(detalle) {
    //this.log(JSON.stringify(detalle))
    if (detalle.cantidad > 0) {
      const inputParams = {
        entidad: {
          cabecera: {
            rut_emisor: Number(this.rutEmpresa),
            sucursal_codigo: Number(this.sucursalEmpresa),
            cliente_proveedor_rut: this.cliente.rut,
            direccion_codigo: this.sucursal.codigo,
            //tipo_dte_codigo:this.tipo.
            lista_precio_codigo: 1,
          },
          descuentosGlobales: this.lastHeaderDataRecibed.descuentosGlobales,
          detalleDocumento: this.cleanDetalledocumento(this.detalleDocumento, false),
        },
        detalle: detalle,
      };
      //console.log('inputParams', JSON.stringify(this.cleanUpdateDetalledocumento(inputParams)))

      this.documentoDetalleService.actualizarDetalle(this.cleanUpdateDetalledocumento(inputParams), ({ mensajes, respuesta }) => {
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        respuesta.registros.forEach((documento) => {
          delete documento.__typename;
        });
        this.onDetalleDocumentoChange.emit(respuesta.registros);
        this.detalleDocumento = respuesta.registros;
        //this.toastService.success('Registro editado con éxito')
        this.obtenerTotalesDocumento(this.lastHeaderDataRecibed);
        this.configInitialDetails(respuesta.registros);
      });
    }
  }

  private cleanUpdateDetalledocumento(inputParams) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = _.cloneDeep(inputParams);
    delete _detalledocumento.detalle.index;

    _detalledocumento.entidad.detalleDocumento.map((detalle) => {
      delete detalle.__typename;
      if (detalle.atributos)
        detalle.atributos.map((attr) => {
          delete attr.__typename;
        });
    });
    return _detalledocumento;
  }
}
